import React, { useState } from 'react';
import styles from './register.module.css'
import dropDown from '../../assets/images/dropDown.svg'
import eyeIcons from '../../assets/images/eyeIcon.svg'

const PrRegister = () => {
  const [step, setStep] = useState(1);
  const nextStep = () => setStep(step + 1);
  const prevStep = () => setStep(step - 1);
  const [activeTab, setActiveTab] = useState("company");
  return (
    <section className={`${styles['register-bg']}`}>
        <div className='row h-100'>
            <div className='container'>
                <div className='col-md-12 h-100 d-flex justify-content-center align-items-center'>
                      {step === 1 && (
                        <div className={`${styles['reg-box']} card`}>
                          <div className={`${styles['reg-body']} card-body`}>
                          <h5 className={`${styles['reg-title']}`}>Register with your mobile number</h5>
                          <p className={`${styles['reg-text']}`}>Let's start with your mobile number.</p>
                          <input type="text" className={`${styles['input-ctm']} form-control my-4`} placeholder="Enter your number" />
                          <div className='form-check mb-3 d-flex align-items-center'>
                          <input type='checkbox' className='form-check-input' id='agree'/>
                          <label className='form-check-label ps-1' for='agree'>
                            I Agree to JobzShala's
                            <a className={`${styles['link-text']} ps-1`} href='#'>Privacy Policy</a>, <a className={`${styles['link-text']}`} href='#'>Terms & Conditions</a>,
                            and Promotional Communication.
                          </label>
                          </div>
                          <button className={`${styles['send-btn']} btn w-100`} onClick={nextStep}>Send OTP</button>
                          <p className={`${styles['acc-text']} text-center pt-3`}>Already have account?<a className={`${styles['link-text']} ps-2`} href='#'>Login Now</a></p>
                          </div>
                        </div>
                      )}

                      {step === 2 && (
                        <div className={`${styles['otp-box']} card`}>
                          <div className={`${styles['reg-body']} card-body`}>
                          <h5 className={`${styles['reg-title']}`}>Verify OTP</h5>
                          <p className={`${styles['reg-text']}`}>We've sent and OTP to your mobile.</p>
                          <div className={`${styles['code-input']} my-4`}>
                              <input type="text" maxlength="1"/>
                              <input type="text" maxlength="1"/>
                              <input type="text" maxlength="1"/>
                              <input type="text" maxlength="1"/>
                              <input type="text" maxlength="1"/>
                              <input type="text" maxlength="1"/>
                          </div>
                          <p className={`${styles['otp-text']} text-center mb-5`}>Don't received ? <strong>Resend in 1:26</strong></p>
                          <button className={`${styles['send-btn']} btn`} onClick={nextStep}>Verify</button>
                        </div>
                        </div>
                      )}

                      {step === 3 && (
                        <div className={`${styles['fill-box']} card`}>
                          <div className={`${styles['reg-body']} card-body`}>
                          <h5 className={`${styles['reg-title']}`}>Basic Details</h5>
                          <p className={`${styles['reg-text']}`}>Tell us a bit about yourself to create your account and secure it.</p>
                            <div className="d-flex justify-content-between mt-3 mb-2">
                                  <button className={`btn ${activeTab === "company" ? styles['comp-btn'] : styles['comp-btn']} w-50 me-1`} onClick={() => setActiveTab("company")}>Company/Business</button>
                                  <button className={`btn ${activeTab === "individual" ? styles['comp-btn'] : styles['comp-btn']} w-50 ms-1`} onClick={() => setActiveTab("individual")}>Individual/Proprietor</button>
                                </div>
                                {activeTab === "company" && (
                                <form>
                                <div className="my-4">
                                   <input type="text" id="contactName" className={`${styles['formctm-control']} form-control`} placeholder="Enter your name" />
                                </div>
                                <div className="my-4">
                                   <input type="email" id="email" className={`${styles['formctm-control']} form-control`} placeholder="Enter your email" />
                                </div>
                                <div className="my-4">
                                   <div className='row'>
                                      <div className='col-md-6'>
                                         <div className="input-group position-relative">
                                            <input type="password" id="password" className={`${styles['formctm-control']} form-control`} placeholder="Enter password" />
                                            <div className={`${styles['eye-icon']}`}>
                                              <img src={eyeIcons}/>
                                            </div>
                                         </div>
                                      </div>
                                      <div className='col-md-6'>
                                         <div className="input-group position-relative">
                                            <input type="password" id="password" className={`${styles['formctm-control']} form-control`} placeholder="Enter password" />
                                            <div className={`${styles['eye-icon']}`}>
                                              <img src={eyeIcons}/>
                                            </div>
                                         </div>
                                      </div>
                                   </div>
                                </div>
                                <div className="d-flex">
                                   <button className={`${styles['verify-btn']} w-50 me-1 btn`} onClick={nextStep}>Send OTP</button>
                                   <button className={`${styles['send-btn']} w-50 ms-1 btn`} onClick={nextStep}>Next</button>
                                </div>
                                <p className={`${styles['acc-text']} text-center pt-3`}>Already have account?<a className={`${styles['link-text']} ps-2`} href='#'>Login Now</a></p>
                             </form>
                                )}
                                 {activeTab === "individual" && (
                                  <form>
                                  <div className="my-4">
                                     <input type="text" id="contactName" className={`${styles['formctm-control']} form-control`} placeholder="Enter your name" />
                                  </div>
                                  <div className="my-4">
                                     <input type="email" id="email" className={`${styles['formctm-control']} form-control`} placeholder="Enter your email" />
                                  </div>
                                  <div className="my-4">
                                     <div className='row'>
                                        <div className='col-md-6'>
                                           <div className="input-group">
                                              <input type="password" id="password" className={`${styles['formctm-control']} form-control`} placeholder="Enter password" />
                                              
                                           </div>
                                        </div>
                                        <div className='col-md-6'>
                                           <div className="input-group">
                                              <input type="password" id="password" className={`${styles['formctm-control']} form-control`} placeholder="Enter password" />
                                              
                                           </div>
                                        </div>
                                     </div>
                                  </div>
                                  <div className="d-flex">
                                     <button className={`${styles['verify-btn']} w-50 me-1 btn`} onClick={nextStep}>Send OTP</button>
                                     <button className={`${styles['send-btn']} w-50 ms-1 btn`} onClick={nextStep}>Next</button>
                                  </div>
                                  <p className={`${styles['acc-text']} text-center pt-3`}>Already have account?<a className={`${styles['link-text']} ps-2`} href='#'>Login Now</a></p>
                               </form>
                                 )}
                        </div>
                        </div>
                      )}

                      {step === 4 && (
                        <div className={`${styles['company-box']} card`}>
                          <div className="card-body">
                          <h5 className={`${styles['reg-title']}`}>Company Details</h5>
                          <p className={`${styles['reg-text']}`}>Enter your company's details to complete registration.</p>
                          <form>
                                <div className='my-4 position-relative'>
                                  <select className={`${styles['formctm-control']} form-control`} aria-label='Default select example'>
                                    <option selected>Open this select menu</option>
                                    <option value='1'>One</option>
                                    <option value='2'>Two</option>
                                    <option value='3'>Three</option>
                                  </select>
                                  <div className={`${styles['drop-img']}`}>
                                    <img src={dropDown}/>
                                  </div>
                                </div>
                                <div className="my-4">
                                   <input type="text" id="contactName" className={`${styles['formctm-control']} form-control`} placeholder="Enter your name" />
                                </div>
                                <div className="my-4">
                                   <input type="email" id="email" className={`${styles['formctm-control']} form-control`} placeholder="Enter your email" />
                                </div>
                                <div className="d-flex">
                                   <button className={`${styles['verify-btn']} w-50 me-1 btn`} onClick={nextStep}>Send OTP</button>
                                   <button className={`${styles['send-btn']} w-50 ms-1 btn`} onClick={nextStep}>Next</button>
                                </div>
                                <p className={`${styles['acc-text']} text-center pt-3`}>Already have account?<a className={`${styles['link-text']} ps-2`} href='#'>Login Now</a></p>
                             </form>
                        </div>
                        </div>
                      )}

                      {step === 5 && (
                        <div className={`${styles['final-box']} card`}>
                          <div className={`${styles['final-body']} card-body text-center`}>
                          <h5 className={`${styles['reg-title']}`}>Thanks for Registration</h5>
                          <p className={`${styles['reg-text']}`}>Enter your company's details to complete registration.</p>
                        </div>
                        </div>
                      )}

                      {/* {step > 1 && step < 5 && (
                        <button className="btn btn-secondary mt-3" onClick={prevStep}>Back</button>
                      )} */}
                </div>
            </div>
        </div>
    </section>
  )
}

export default PrRegister